import { defineStore, acceptHMRUpdate } from "pinia";
import Api from "@/axios";
import { userLogin } from "@/plugins/casl/ability";

const defaultGroup = [
    { type: 4, group_id: 1 },
    { type: 5, group_id: 2 },
    { type: 6, group_id: 2 },
];

export const useAuthStore = defineStore("auth", {
    state: () => ({
        user: userLogin.data,
        detail: null,
        loading: false,
    }),
    getters: {
        isLogin: (state) => (state.user != null ? true : false),
        isIos: () => {
            return (
                /iPad|iPhone|Macintosh|iPod/.test(navigator.userAgent) &&
                !window.MSStream
            );
        },
        //cek apakah student sudah mengatur jadwal shift
        studentShiftGroup: (state) => {
            if (state.user.type >= 4) {
                return state.user.student_detail.shift_group_id;
            } else {
                return 1;
            }
        },
        //cek apakah user memiliki jadwal default
        defaultShiftGroup: (state) =>
            defaultGroup.find((x) => x.type == state.user.type.id),
    },
    actions: {
        saveData(value) {
            if (value) {
                this.user = value;
            }
        },
        getDetail() {
            this.loading = true;
            return new Promise((resolve, reject) => {
                Api.get("user-detail")
                    .then((res) => {
                        this.detail = res.data;
                        this.loading = false;
                        resolve(res);
                    })
                    .catch((error) => {
                        this.loading = false;
                        reject(error);
                    });
            });
        },
        async getAuthData() {
            try {
                const res = await Api.get('/auth')
                this.user = res.data
            } catch (error) {
                console.log(error);
            }
        }
    },
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
